import { invariant } from '@epic-web/invariant'
import React from 'react'
import { type GeneratedImage2 as GeneratedImage } from '#app/routes/resources+/generated-images'
import { decodeImageFormat, WORKFLOWS } from '#app/utils/helpers'
import { useSelectionContext } from './image-selection-context'
import { Button } from './ui/button'
import { Icon } from './ui/icon'
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from './ui/tooltip'

interface ImageActionButtonsProps {
	image: GeneratedImage
}

export const ImageActionButtons: React.FC<ImageActionButtonsProps> = ({
	image,
}) => {
	const { ratio } = decodeImageFormat(image.format)
	const isWideImage = ratio.width / ratio.height > 1
	const { handleDialogImageClick } = useSelectionContext()

	const imageId = image.url.split('/').pop()

	invariant(handleDialogImageClick, 'handleDialogImageClick is required')
	const buttons: {
		icon: 'download-simple' | 'caret-double-up'
		className: string
		onClick: (e: React.MouseEvent) => void
		tooltip?: string
	}[] = [
		// {
		//  icon: 'mask-happy',
		//  className: 'bg-red-600 hover:bg-red-700',
		//  onClick: e => {
		//      e.stopPropagation()
		//      handleDialogImageClick(image, WORKFLOWS.faceDetailer)
		//  },
		//  tooltip: 'Enhance face details',
		// },
		{
			icon: 'download-simple',
			className: 'bg-gray-200 hover:bg-gray-300 text-seafoam-1100',
			onClick: (e) => {
				e.stopPropagation()
				window.location.href = `/resources/download-image/${image.ownerId}/${imageId}`
			},
			tooltip: 'Download image',
		},
		{
			icon: 'caret-double-up',
			className: 'bg-gray-200 hover:bg-gray-300 text-magenta-1000',
			onClick: (e) => {
				e.stopPropagation()
				handleDialogImageClick(image, WORKFLOWS.upscaler)
			},
			tooltip: 'Upscale image',
		},
	]
	return (
		<div
			className={`absolute right-2 top-1 flex ${isWideImage ? 'flex-row' : 'flex-col'} z-10 justify-end gap-1.5`}
		>
			{buttons.map((button) => (
				<TooltipProvider key={button.icon}>
					<Tooltip key={button.icon} delayDuration={300}>
						<TooltipTrigger asChild>
							<Button
								variant="ghost"
								size="icon"
								className={`group flex h-8 w-8 items-center justify-center rounded-full border-1 border-gray-400 ${button.className} transform bg-opacity-50 p-0 backdrop-blur-sm transition-all duration-200 ease-in-out hover:scale-105 hover:bg-opacity-70`}
								onClick={button.onClick}
							>
								<Icon
									name={button.icon}
									className="text-sm opacity-80 transition-opacity duration-200 ease-in-out group-hover:opacity-100"
								/>
							</Button>
						</TooltipTrigger>
						<TooltipContent side="left" className="z-50">
							<p>{button.tooltip}</p>
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>
			))}
		</div>
	)
}
